import * as Document from "~/Document";
import * as Driver from "~/Driver";
import { Order } from "~/Order";
import { Time } from "~/Time";

export type Type = ReturnType<
  typeof dateOfCreation | typeof driver | typeof documentType | typeof reference
>;

export const dateOfCreation = () => "DATE" as const;
export const driver = () => "DRIVER" as const;
export const documentType = () => "TYPE" as const;
export const reference = () => "REFERENCE" as const;

export const toOrdering = (type: Type): Order<Document.Document> =>
  Order.fromCompare((a, b) => {
    switch (type) {
      case dateOfCreation():
        return Time.DateTime.compare(a, b);
      case driver():
        return Order.optionally(Driver.Name.compare)(
          a.driver.name,
          b.driver.name
        );
      case documentType():
        return Order.optionally(Order.string().compare)(a.type, b.type);
      case reference():
        return Order.optionally(Order.string().compare)(
          a.reference,
          b.reference
        );
    }
  });
